import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalTrackingComponent } from '../../../Component/ApprovalTracking/approval-tracking/approval-tracking.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-tax-declaration-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent, NgbCollapse],
  templateUrl: './tax-declaration-detail.component.html',
  styleUrl: './tax-declaration-detail.component.scss'
})
export class TaxDeclarationDetailComponent {
  isDisabled: boolean = false;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;
  DetailData = {
    TransactionId: null,
    Table: [
      {
        ESS_EmpTaxDeclarationID: null,
        EmpMasterId: null,
        EmpCode: null,
        EmpName: null as any,
        IsNewRegime: null,
        FinancialYearStart: null,
        FinancialYearEnd: null,
        ApprovalStatus: null as any,
        Photo: null as any,
        ESS_EmpTaxInvestmentId: 0,
        EmpType: null
      }
    ],
    Table1: [
      {
        ESS_EmpTaxDeclarationDetailsId: null,
        ESS_EmpTaxDeclarationID: null,
        ESS_TaxSectionMasterId: null,
        ESS_TaxSectionMasterId1: null,
        SectionCode: null,
        SectionName: null,
        IncomeHead: null,
        SectionDescription: null,
        IsOldRegimeApplicable: true,
        IsOldMaxlimitapplicable: false,
        OldRegimeMaxAmount: 0.00,
        IsNewRegimeApplicable: true,
        IsNewMaxlimitapplicable: false,
        NewRegimeMaxAmount: 0.00,
        SubSectionName: null,
        SubSectionDescription: null,
        DeclaredAmount: null,
        ApprovedAmount: null,
      }
    ],
    Table2: [
      {
        ESS_TaxPreviousEmploymentDetailsID: null,
        ESS_EmpTaxDeclarationID: null,
        Monthname: null,
        Yearname: null,
        Basic: null,
        DA: null,
        HRA: null,
        OtherAllowance: null,
        GrossAmount: null,
        PT: null,
        PF: null,
        TDS: null,
        OtherDeduction: null,
        NetAmount: null,
        Remarks: null
      }
    ],
    Table3: [
      {
        ESS_EmpTaxDeclarationDetails_HRAID: null,
        ESS_EmpTaxDeclarationID: null,
        FromDate: null,
        ToDate: null,
        NameOfLandlord: null,
        LandLordPanNo: null,
        Address: null,
        IsMetroCity: null,
        DeclaredAmount: null,
        ApprovedAmount: null,
      }
    ],
    Table4: [
      {
        ESS_EmpTaxDeclarationDetails_OthersID: null,
        ESS_EmpTaxDeclarationID: null,
        ESS_TaxSectionDetailId: null,
        SubSectionName: null,
        SubSectionDescription: null,
        IsOldRegimeApplicable: true,
        IsOldMaxlimitapplicable: false,
        OldRegimeMaxAmount: 0.00,
        IsNewRegimeApplicable: true,
        IsNewMaxlimitapplicable: false,
        NewRegimeMaxAmount: 0.00,
        DeclaredAmount: null,
        ApprovedAmount: null,
      }
    ],
    Table5: [
      {
        ESS_EmpTaxDeclarationDetails_LOPID: null,
        ESS_EmpTaxDeclarationID: null,
        AnnualRentReceived: null,
        NetAnnualValue: null,
        StandardDeduction: null,
        RepayingHomeLoanForThisProperty: null,
        PrincipalPaidOnHomeLoan: null,
        MunicipalTaxesPaid: null,
        InterestPaidOnHomeLoan: null,
        NameOfTheLender: null,
        LenderPanNo: null,
        NetIncomeLossFromHouseProperty: null,
      }
    ]
  };

  Trackings = [];
  TrackingsUser = [];
  user = [] as any;

  OpenCard = {
    CardPreviousEmployment: true as any,
    CardEmpTaxDeclarationDetails: true as any,
    CardEmpTaxDeclarationDetails_HRA: true as any,
    CardEmpTaxDeclarationDetails_Others: true as any,
    CardEmpTaxDeclarationDetails_LOP: true as any,
  }

  Filter = {
    ModuleMasterId: 9,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    IsDraft: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    private incometax: IncometaxService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    //this.route.params.subscribe(params => this.Filter.IsDraft = params['draft'] == 'true' ? true : false);
    this.GetID = 2
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
    } else if (this.GetID == 2) {
      this.ESS_EmpTaxDeclarationSelect();
    }
  }

  ESS_EmpTaxDeclarationSelect() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxDeclarationSelect({ SelectType: 'S', ESS_EmpTaxDeclarationID: this.Filter.WebESSApprovalRequestTrackingId, EmpMasterId: this.user.UserType == 'A' ? 0 : this.user.UserId, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: null, ApprovalStatus: this.user.UserType == 'A' ? 'Approved' : 'ALL' }).subscribe({
      next: (response) => {
        if (response) {
          this.DetailData = response;
          this.DetailData.TransactionId = this.DetailData.Table[0].ESS_EmpTaxDeclarationID;
          this.Filter.IsDraft = response.Table[0].IsDraft;
        }
        this.isDisabled = false;
      },
      complete: () => {
        //this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.Table[0].EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.Table[0].ApprovalStatus) == 'pending') {
          this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
          this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Cancel() {
    if (this.user.UserType == 'A') {
      this.router.navigate(['/incometax/incometax/']);
    } else {
      this.router.navigate(['/request/incometax/taxdeclaration/']);
    }
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  onSwitchChange(event: any, cardname: string) {
    if (cardname == "CardPreviousEmployment") {
      this.OpenCard.CardPreviousEmployment = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails") {
      this.OpenCard.CardEmpTaxDeclarationDetails = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
      this.OpenCard.CardEmpTaxDeclarationDetails_HRA = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
      this.OpenCard.CardEmpTaxDeclarationDetails_Others = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
      this.OpenCard.CardEmpTaxDeclarationDetails_LOP = event.target.checked;
    }
  }

  Tracking() {
    const modalRef = this.modalService.open(ApprovalTrackingComponent, { size: 'lg' });
    modalRef.componentInstance.Detail.ModuleMasterId = this.Filter.ModuleMasterId;
    modalRef.componentInstance.Detail.EmpMasterId = this.Filter.EmpMappingId;
    modalRef.componentInstance.Detail.TransactionId = this.DetailData.TransactionId;
    modalRef.componentInstance.Detail.UserImage = this.DetailData.Table[0].Photo;
    modalRef.componentInstance.Detail.EmployeeName = this.DetailData.Table[0].EmpName;
    modalRef.componentInstance.Detail.EmpCode = this.DetailData.Table[0].EmpCode;
    modalRef.componentInstance.Detail.DesignationName = "";
    modalRef.result.then(result => { });
  }

  async Delete() {
    if (this.user.UserType == 'A') {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to delete?';
      modalRef.result.then((result) => {
        if (result) {
          this.isDisabled = true;
          this.incometax.ESS_EmpTaxDeclaration_InsertUpdate({
            SelectType: 'AdminDelete', ESS_EmpTaxDeclarationID: this.DetailData.Table[0].ESS_EmpTaxDeclarationID, IsAdminEntry: true,
            FinancialYearStart: this.DetailData.Table[0].FinancialYearStart, FinancialYearEnd: this.DetailData.Table[0].FinancialYearEnd, EmpMasterId: this.DetailData.Table[0].EmpMasterId
          }).subscribe({
            next: async (response) => {
              if (response.Error_Code == '744') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Cancel()
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    }
  }

  GenerateTDSReport() {
    this.isDisabled = true;
    this.incometax.GenerateTDSReport({
      OperationType: 'Declaration',
      Emptype: this.common.ToLowerCase(this.DetailData.Table[0].EmpType??'') == 'subcontractor'?'Front':this.DetailData.Table[0].EmpType,
      EmpmasterID: this.DetailData.Table[0].EmpMasterId,
      TaxMainID: this.DetailData.Table[0].ESS_EmpTaxDeclarationID,
      IsNewRegime: this.DetailData.Table[0].IsNewRegime,
      FinancialYearStart: new Date(this.DetailData.Table[0].FinancialYearStart ?? '').getFullYear(),
      FinancialYearEnd: new Date(this.DetailData.Table[0].FinancialYearEnd ?? '').getFullYear(),
      IsDraft: null
    }).subscribe({
      next: (response) => {
        if (response && response.ftpFileName) {
          window.open(response.ftpFileName, '_blank');
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}